import React, { useEffect, useContext } from "react";
import { useForm, Controller } from "react-hook-form";
import moment from "moment";
import clsx from "clsx";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import {
  Grid,
  Paper,
  Box,
  Button,
  ListItemIcon,
  ListItemText,
} from "@material-ui/core";
import LobConstants from "../../../../constants/LobConstants";
import PathsandTitle from "../../../../constants/pathsAndTitle";
// import PageHeadingListViewWithoutNavigation from "../../../../components/PageHeadingDSRListView";
import PageHeadingListView from "../../../../components/PageHeadingListView";
import StyledMenuItem from "../../../../components/Menu/StyledMenuItem";
import DateRangePicker from "../../../../components/DateRangePicker";
import useStyles from "../../../../themes/makeStyles";
import Autocomplete from "../../../../components/AutoComplete";
import TextField from "../../../../components/TextField";
import GlobalContext from "../../../../common/contexts/GlobalContext";
import PickListOptions from "../../../../constants/PickListOptions";
import SearchResults from "./SearchResults";
import { default as Apiservices } from "../../../../common";
import SkeletonComponent from "../../../../components/SkeletonComponent";

const DEFAULT_PAGINATION_OPTIONS =
  LobConstants.DEFAULT_LIST_VIEW_PAGINATION_OPTIONS;
export default function ScheduleMaintenanceList() {
  const defaultValues = {
    rake_name: "",
  };
  const { control, handleSubmit, register, errors, reset, watch, getValues } =
    useForm({
      defaultValues,
    });
  const [paginationInfo, setPaginationInfo] = React.useState([]);
  const { masterDatacontext } = useContext(GlobalContext);
  const { masterDataObj } = masterDatacontext;
  const [order, setOrder] = React.useState(true);
  const [page, setPage] = React.useState(1);
  const [relativePage, setRelativePage] = React.useState(1);
  const [filterlist, setFilterlist] = React.useState(null);
  const [orderBy, setOrderBy] = React.useState("rake_name");
  const [
    scheduleMaintenancelistMainData,
    setScheduleMaintenancelistMainData,
  ] = React.useState([]);
  const [
    scheduleMaintenanceListDetails,
    setScheduleMaintenancelistDetails,
  ] = React.useState();
  const [loading, setLoading] = React.useState(true);
  const [noFetch, setNoFetch] = React.useState(false);
  const [fetchMoredata, setFetchMoreData] = React.useState(false);
  const [resetvalues, setResetvalues] = React.useState(true);
  const [showSearchFlag, setshowSearchFlag] = React.useState(true);
  const [searchlist, setSearchlist] = React.useState(true);
  const [searchTerm, setSearchTerm] = React.useState("");
  const [queryparams, setqueryparams] = React.useState({});
  const [searchResultsEmpty, setSearchResultsEmpty] = React.useState(false);
  const [searchCriteria, setSearchCriteria] = React.useState({
    examination_type: "",
  });

  const handleSearchClick = async () => {
    setshowSearchFlag(!showSearchFlag);
    setSearchlist(showSearchFlag ? "searchlist" : "searchlist");
    if (!showSearchFlag) {
      resetForm();
    }
  };
  const handleSearchFilterClick = async () => {
    console.log("Search Filter Clicked");
    setSearchlist(!searchlist);
    setshowSearchFlag(searchlist ? "showSearchFlag" : "showSearchFlag");
    if (!searchlist) {
      resetForm();
    }
  };

  const [maintenanceTypeListOptions] = React.useState(
    PickListOptions.TYPE_OF_MAINTENANCE_OPTIONS
  );

  const [scheduleStatusTypeListOptions] = React.useState(
    PickListOptions.SCHEDULE_STATUS_OPTIONS
  );

  const [rakeListOptions, setRakeListDropdown] = React.useState([]);

  const setMasterDropdownOptions = (masterDataObj) => {
    let listRakeNames = [];
    masterDataObj.records.map((odObj) => {
      let rakeNamesObj = {};
      rakeNamesObj.value = odObj.rake_name;
      rakeNamesObj.label = odObj.rake_name;
      listRakeNames.push(rakeNamesObj);
    });
    setRakeListDropdown(listRakeNames);
  };

  useEffect(() => {
    const fetchData = async () => {
      const ScheduleMaintenanceListDetails =
        await Apiservices.getScheduleMaintenanceList();
      console.log(
        ScheduleMaintenanceListDetails,
        "Schedule Maintenance details::::::::::::::::"
      );
      setScheduleMaintenancelistMainData(
        ScheduleMaintenanceListDetails.records
      );
      handleDisplayScheduleMaintenanceData(
        ScheduleMaintenanceListDetails.records,
        DEFAULT_PAGINATION_OPTIONS.DEFAULT_RECORDS_PER_PAGE,
        0
      );
      handlePagination(
        ScheduleMaintenanceListDetails.paginationInfo,
        DEFAULT_PAGINATION_OPTIONS.DEFAULT_RECORDS_PER_PAGE
      );
      if (
        ScheduleMaintenanceListDetails.records.length ==
        ScheduleMaintenanceListDetails.paginationInfo.totalrecords
      ) {
        setNoFetch(true);
      }
      setLoading(false);
    };

    const fetchRakeMasterData = async () => {
      const RakeMasterListDetails =
        await Apiservices.searchRakeMaster();
      console.log(
        RakeMasterListDetails,
        "Rake Master detaisls::::::::::::::::"
      );
      
      setMasterDropdownOptions(RakeMasterListDetails);
      setLoading(false);
    };

    fetchData();
    fetchRakeMasterData();
  }, [masterDataObj]);

  useEffect(() => {
    let enteredText = getValues("search");
    handleSearchFilter(enteredText);
  }, [watch("search")]);

  useEffect(() => {
    if (!showSearchFlag || !searchlist) {
      console.log("Reset Form Here");
      resetForm();
    }
  }, [showSearchFlag, searchlist]);

  const handleFilterClick = (event) => {
    setFilterlist(event.currentTarget);
  };

  const handleFilterClose = (event) => {
    setFilterlist(null);
  };

  const handleSelectedFilter = (event) => {
    console.log(event.currentTarget.dataset.myValue);
    setOrderBy(event.currentTarget.dataset.myValue);
    if (orderBy === event.currentTarget.dataset.myValue) {
      setOrder(!order);
      setPage(1);

      let SortedData = sortFunctionText(
        scheduleMaintenancelistMainData,
        getComparator(!order, event.currentTarget.dataset.myValue)
      );
      setScheduleMaintenancelistMainData(SortedData);
      handleDisplayScheduleMaintenanceData(
        SortedData,
        DEFAULT_PAGINATION_OPTIONS.DEFAULT_RECORDS_PER_PAGE,
        0
      );
    } else {
      setPage(1);
      let SortedData = sortFunctionText(
        scheduleMaintenancelistMainData,
        getComparator(order, event.currentTarget.dataset.myValue)
      );

      setScheduleMaintenancelistMainData(SortedData);
      handleDisplayScheduleMaintenanceData(
        SortedData,
        DEFAULT_PAGINATION_OPTIONS.DEFAULT_RECORDS_PER_PAGE,
        0
      );
    }
  };

  const handleDisplayScheduleMaintenanceData = (
    dsrData,
    recordsPerPage,
    page
  ) => {
    console.log(page);
    console.log(
      dsrData.slice(
        page * recordsPerPage,
        page * recordsPerPage + recordsPerPage
      )
    );
    setScheduleMaintenancelistDetails(
      dsrData.slice(
        page * recordsPerPage,
        page * recordsPerPage + recordsPerPage
      )
    );
  };

  const handlePagination = (paginationInfo, recordsPerPage) => {
    let paginationdata = {
      totalpages: Math.ceil(paginationInfo.totalrecords / recordsPerPage),
      cachepage: paginationInfo.currentpage,
      totalcachepages: paginationInfo.totalpages,
    };
    setPaginationInfo(paginationdata);
    setFetchMoreData(paginationInfo.recordStatus);
  };

  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  function getComparator(order, orderBy) {
    return order
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  function descendingComparatorDate(a, b, orderBy) {
    if (
      moment(b[orderBy]).format("YYYY-MM-DD") <
      moment(a[orderBy]).format("YYYY-MM-DD")
    ) {
      return -1;
    }
    if (
      moment(b[orderBy]).format("YYYY-MM-DD") >
      moment(a[orderBy]).format("YYYY-MM-DD")
    ) {
      return 1;
    }
    return 0;
  }

  // function getComparatorDate(order, orderBy) {
  //   return order
  //     ? (a, b) => descendingComparatorDate(a, b, orderBy)
  //     : (a, b) => -descendingComparatorDate(a, b, orderBy);
  // }

  function sortFunctionText(array, comparator) {
    console.log(array);

    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });

    return stabilizedThis.map((el) => el[0]);
  }

  // function sortFunctionDate(array, comparator) {
  //   const stabilizedThis = array.map((el, index) => [el, index]);
  //   stabilizedThis.sort((a, b) => {
  //     const order = comparator(a[0], b[0]);
  //     if (order !== 0) return order;
  //     return a[1] - b[1];
  //   });
  //   return stabilizedThis.map((el) => el[0]);
  // }
  function FilterList() {
    return (
      <div>
        <StyledMenuItem
          onClick={handleSelectedFilter}
          data-my-value={"rake_name"}
          className={
            orderBy == "rake_name" ? classes.dropDownMenuActive : ""
          }
        >
          <ListItemIcon>
            <ArrowUpwardIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Rake Name" />
        </StyledMenuItem>
        <StyledMenuItem
          onClick={handleSelectedFilter}
          data-my-value={"schedule_type"}
          className={
            orderBy == "schedule_type"
              ? classes.dropDownMenuActive
              : ""
          }
        >
          <ListItemIcon>
            <ArrowUpwardIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Schedule Type" />
        </StyledMenuItem>
      </div>
    );
  }

  const getRelativePageNumber = (newpage, chachePageno) => {
    return (
      newpage -
      Math.ceil(
        ((chachePageno - 1) *
          DEFAULT_PAGINATION_OPTIONS.RECORDS_PER_CACHED_PAGE) /
          DEFAULT_PAGINATION_OPTIONS.DEFAULT_RECORDS_PER_PAGE
      )
    );
  };

  const handleChangePage = async (event, newPage) => {
    if (noFetch) {
      setScheduleMaintenancelistDetails(
        scheduleMaintenancelistMainData.slice(
          (newPage - 1) * DEFAULT_PAGINATION_OPTIONS.DEFAULT_RECORDS_PER_PAGE,
          newPage * DEFAULT_PAGINATION_OPTIONS.DEFAULT_RECORDS_PER_PAGE
        )
      );
      setPage(newPage);
    } else {
      if (fetchMoredata || newPage === 1) {
        if (
          newPage === 1 ||
          newPage * DEFAULT_PAGINATION_OPTIONS.DEFAULT_RECORDS_PER_PAGE +
            DEFAULT_PAGINATION_OPTIONS.DEFAULT_RECORDS_PER_PAGE >=
            scheduleMaintenancelistMainData.length * paginationInfo.cachepage
        ) {
          let chachePageno = Math.ceil(
            (newPage * DEFAULT_PAGINATION_OPTIONS.DEFAULT_RECORDS_PER_PAGE +
              DEFAULT_PAGINATION_OPTIONS.DEFAULT_RECORDS_PER_PAGE) /
              DEFAULT_PAGINATION_OPTIONS.RECORDS_PER_CACHED_PAGE
          );
          let queryparams = {
            limit: DEFAULT_PAGINATION_OPTIONS.RECORDS_PER_CACHED_PAGE,
            pageno: chachePageno,
            rake_name: searchCriteria.rake_name,
            schedule_type: searchCriteria.schedule_type
          };
          let ScheduleMaintenanceListDetails = await Apiservices.getScheduleMaintenanceList(queryparams);
          setScheduleMaintenancelistMainData(
            ScheduleMaintenanceListDetails.records
          );

          setRelativePage(getRelativePageNumber(newPage, chachePageno));
          setFetchMoreData(
            ScheduleMaintenanceListDetails.paginationInfo.recordStatus
          );
          setPage(newPage);
          handleDisplayScheduleMaintenanceData(
            ScheduleMaintenanceListDetails.records,
            DEFAULT_PAGINATION_OPTIONS.DEFAULT_RECORDS_PER_PAGE,
            getRelativePageNumber(newPage, chachePageno)
          );

          setPaginationInfo({
            ...paginationInfo,
            cachepage: Math.ceil(
              (newPage * DEFAULT_PAGINATION_OPTIONS.DEFAULT_RECORDS_PER_PAGE +
                DEFAULT_PAGINATION_OPTIONS.DEFAULT_RECORDS_PER_PAGE) /
                DEFAULT_PAGINATION_OPTIONS.RECORDS_PER_CACHED_PAGE
            ),
          });
        } else {
          setScheduleMaintenancelistDetails(
            scheduleMaintenancelistMainData.slice(
              (newPage - 1) *
                DEFAULT_PAGINATION_OPTIONS.DEFAULT_RECORDS_PER_PAGE,
              newPage * DEFAULT_PAGINATION_OPTIONS.DEFAULT_RECORDS_PER_PAGE
            )
          );
          setRelativePage(relativePage + (newPage - page));
          setPage(newPage);
        }
      } else {
        if (relativePage + (newPage - page) < 1) {
          console.log("fetch more true");
          setFetchMoreData(true);
        }

        setScheduleMaintenancelistDetails(
          scheduleMaintenancelistMainData.slice(
            (newPage - 1) * DEFAULT_PAGINATION_OPTIONS.DEFAULT_RECORDS_PER_PAGE,
            newPage * DEFAULT_PAGINATION_OPTIONS.DEFAULT_RECORDS_PER_PAGE
          )
        );
        setRelativePage(relativePage + (newPage - page));
        setPage(newPage);
      }
    }
  };

  const handleSearchCriteriaSubmit = async (submitteddata) => {
    console.log(submitteddata);
    setLoading(true);
    let queryparams = {};
    queryparams.rake_name = submitteddata.rake_name
      ? submitteddata.rake_name.label
      : null;
    queryparams.schedule_type = submitteddata.schedule_type
      ? submitteddata.schedule_type.label
      : null;
    queryparams.schedule_status = submitteddata.schedule_status
      ? submitteddata.schedule_status.label
      : null;
    console.log(submitteddata, queryparams);
    let ScheduleMaintenanceListDetails =
      await Apiservices.getScheduleMaintenanceList(queryparams);
    if (
      !ScheduleMaintenanceListDetails ||
      (ScheduleMaintenanceListDetails.records &&
        ScheduleMaintenanceListDetails.records.length) == 0
    )
      setSearchResultsEmpty(true);
    else setSearchResultsEmpty(false);
    setSearchCriteria(queryparams);
    console.log(ScheduleMaintenanceListDetails);
    setScheduleMaintenancelistMainData(
      ScheduleMaintenanceListDetails.records
    );
    handleDisplayScheduleMaintenanceData(
      ScheduleMaintenanceListDetails.records,
      DEFAULT_PAGINATION_OPTIONS.DEFAULT_RECORDS_PER_PAGE,
      0
    );
    handlePagination(
      ScheduleMaintenanceListDetails.paginationInfo,
      DEFAULT_PAGINATION_OPTIONS.DEFAULT_RECORDS_PER_PAGE
    );
    setPage(1);
    setLoading(false);
  };

  const handleSearchFilter = (enteredText) => {
    console.log("Event Current Target Here --- ");
    let enterdText = enteredText;
    setSearchTerm(enterdText);
    const filteredList = scheduleMaintenancelistMainData.filter((n) => {
      console.log("searchterm", searchTerm);
      try {
        return (
          n.rake_name
            .toString()
            .toUpperCase()
            .includes(enterdText.toString().toUpperCase()) ||
          n.schedule_type
            .toString()
            .toUpperCase()
            .includes(enterdText.toString().toUpperCase()) ||
          n.rake_composition
            .toString()
            .toUpperCase()
            .includes(enterdText.toString().toUpperCase()) ||
          n.rake_type
            .toString()
            .toUpperCase()
            .includes(enterdText.toString().toUpperCase()) ||
          n.last_unloading_point
            .toString()
            .toUpperCase()
            .includes(enterdText.toString().toUpperCase())

        );
      } catch {
        return false;
      }
    });
    handleDisplayScheduleMaintenanceData(
      filteredList,
      DEFAULT_PAGINATION_OPTIONS.DEFAULT_RECORDS_PER_PAGE,
      0
    );
    let paginationInfo = {
      totalrecords: filteredList.length,
      currentpage: 1,
      totalpages:
        filteredList.length /
        DEFAULT_PAGINATION_OPTIONS.DEFAULT_RECORDS_PER_PAGE,
      recordStatus: true,
    };
    handlePagination(
      paginationInfo,
      DEFAULT_PAGINATION_OPTIONS.DEFAULT_RECORDS_PER_PAGE
    );

    setPage(1);
  };

  const resetForm = async () => {
    setResetvalues(!resetvalues);
    reset();
    let ScheduleMaintenanceList = await Apiservices.getScheduleMaintenanceList(queryparams);
    setScheduleMaintenancelistMainData(ScheduleMaintenanceList.records);
    handleDisplayScheduleMaintenanceData(
      ScheduleMaintenanceList.records,
      DEFAULT_PAGINATION_OPTIONS.DEFAULT_RECORDS_PER_PAGE,
      0
    );
    handlePagination(
      ScheduleMaintenanceList.paginationInfo,
      DEFAULT_PAGINATION_OPTIONS.DEFAULT_RECORDS_PER_PAGE
    );
    setPage(1);
  };
  const classes = useStyles();
  return (
    <div>
      <PageHeadingListView
        headingtitle={PathsandTitle.TitlesHeading.ScheduleMaintenance}
        headingpath={PathsandTitle.TitlesNavigation.ScheduleMaintenance}
        buttontitle={PathsandTitle.PathsHeading.ScheduleMaintenance}
        buttonpath={PathsandTitle.PathsNavigation.ScheduleMaintenance}
        buttonhandleSearchClick={handleSearchClick}
        buttonhandleSearchFilterClick={handleSearchFilterClick}
        buttonhandleFilterClick={handleFilterClick}
        filterliststate={filterlist}
        filterlist={<FilterList />}
        handlefilterclose={handleFilterClose}
      />
      <Box mt={1}>
        {searchlist ? (
          <div />
        ) : (
          <Grid
            container
            direction="row"
            justify="flex-end"
            alignItems="center"
          >
            <Grid item>
              <Box>
                <TextField
                  name="search"
                  type={"text"}
                  disabled={false}
                  required={false}
                  rules={{ required: false }}
                  label="Search String"
                  placeholder="Search String"
                  control={control}
                  getValueChanged={handleSearchFilter}
                />
              </Box>
            </Grid>
          </Grid>
        )}
      </Box>
      <form
        onSubmit={handleSubmit(handleSearchCriteriaSubmit)}
        id="list-dsr"
        key={resetvalues}
      >
        <Box mt={1}>
          {showSearchFlag ? (
            <div />
          ) : (
            <Box py={1}>
              <Paper elevation={0}>
                <Box pt={1} ml={1}>
                  <h3 className={classes.secondHeading}>Search</h3>
                </Box>
                <Box p={3}>
                  <Grid container spacing={2}>
                    <Grid item xs={6} sm={4}>
                      <Autocomplete
                        name="rake_name"
                        control={control}
                        Values={rakeListOptions}
                        disabled={false}
                        label="Rake Name"
                      />
                    </Grid>
                    <Grid item xs={6} sm={4}>
                      <Autocomplete
                          name="schedule_type"
                          control={control}
                          Values={maintenanceTypeListOptions}
                          disabled={false}
                          label="Schedule Type"
                        />
                    </Grid>
                    <Grid item xs={6} sm={4}>
                      <Autocomplete
                          name="schedule_status"
                          control={control}
                          Values={scheduleStatusTypeListOptions}
                          disabled={false}
                          label="Schedule Status"
                        />
                    </Grid>
                  </Grid>
                </Box>
                <Box px={3} py={2}>
                  <Grid container spacing={5} justify="flex-end">
                    <Grid item>
                      <Button
                        variant="contained"
                        color="primary"
                        className={clsx(
                          classes.subTextButton,
                          "btnMinWidthSearch",
                          "mr-1"
                        )}
                        type="submit"
                      >
                        Search
                      </Button>

                      <Button
                        variant="outlined"
                        className={clsx(
                          classes.subTextButton,
                          "btnMinWidthSearch"
                        )}
                        onClick={resetForm}
                      >
                        Clear
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
              </Paper>
            </Box>
          )}
        </Box>
      </form>
      {loading ? (
        <SkeletonComponent />
      ) : (
        <SearchResults
          tableData={scheduleMaintenanceListDetails}
          handleChangePage={handleChangePage}
          isLoading={loading}
          paginationInfo={paginationInfo}
          searchResultsEmpty={searchResultsEmpty}
          page={page}
        />
      )}
    </div>
  );
}
